export class HoldingViewsInsightState {
  public startDate: Date;
  public endDate: Date;

  static fromJson(obj: any) {
    const model = new HoldingViewsInsightState();
    model.startDate = new Date(obj.startDate);
    model.endDate = new Date(obj.endDate);
    return model;
  }
}

export class HoldingReportViewsInsightState {
  public startDate: Date;
  public endDate: Date;
  public holdingId: number;

  static fromJson(obj: any) {
    const model = new HoldingReportViewsInsightState();
    model.startDate = new Date(obj.startDate);
    model.endDate = new Date(obj.endDate);
    model.holdingId = +obj.holdingId;
    return model;
  }
}

export class ReportViewsInsightState {
  public startDate: Date;
  public endDate: Date;

  static fromJson(obj: any) {
    const model = new ReportViewsInsightState();
    model.startDate = new Date(obj.startDate);
    model.endDate = new Date(obj.endDate);
    return model;
  }
}

export class TotalHoldingReportsViewsInsightState {
  public startDate: Date;
  public endDate: Date;

  static fromJson(obj: any) {
    const model = new TotalHoldingReportsViewsInsightState();
    model.startDate = new Date(obj.startDate);
    model.endDate = new Date(obj.endDate);
    return model;
  }
}

export class InvestorInteractionsInsightState {
  public pageSize: number;

  static fromJson(obj: any) {
    const model = new InvestorInteractionsInsightState();
    if (obj.pageSize) {
      model.pageSize = +obj.pageSize;
    }
    return model;
  }
}


export class InsightsUiState {
  public isSidebarOpened: boolean;

  public holdingViewsInsightState: HoldingViewsInsightState;
  public holdingReportViewsInsightState: HoldingReportViewsInsightState;
  public reportViewsInsightState: ReportViewsInsightState;
  public investorInteractionsInsightState: InvestorInteractionsInsightState;
  public totalHoldingReportsViewsInsightState: TotalHoldingReportsViewsInsightState;

  constructor() {
    this.isSidebarOpened = true;
    this.holdingViewsInsightState = null;
  }

  static fromJson(obj: any): InsightsUiState {
    const model = new InsightsUiState();
    if (obj) {
      model.isSidebarOpened = obj.isSidebarOpened;

      // insight 1
      if (obj.holdingViewsInsightState) {
        model.holdingViewsInsightState = HoldingViewsInsightState.fromJson(
          obj.holdingViewsInsightState
        );
      }

      // insight 2
      if (obj.holdingReportViewsInsightState) {
        model.holdingReportViewsInsightState = HoldingReportViewsInsightState.fromJson(
          obj.holdingReportViewsInsightState
        );
      }

      // insight 3
      if (obj.reportViewsInsightState) {
        model.reportViewsInsightState = ReportViewsInsightState.fromJson(
          obj.reportViewsInsightState
        );
      }

      // insight 4
      if (obj.investorInteractionsInsightState) {
        model.investorInteractionsInsightState = InvestorInteractionsInsightState.fromJson(
          obj.investorInteractionsInsightState
        );
      }

      // insight 5
      if (obj.totalHoldingReportsViewsInsightState) {
        model.totalHoldingReportsViewsInsightState = TotalHoldingReportsViewsInsightState.fromJson(
          obj.totalHoldingReportsViewsInsightState
        );
      }
    }

    return model;
  }
}
